import React, { Fragment } from "react";
import { Field } from "formik";
import { withNamespace } from "../../../../util/forms/with-namespace";
import { AMOUNT } from "./field-names";
import { SubscriptionsMeta } from "../../../../util/subscription/subscriptions";
import { SubscriptionType } from "../../../../util/subscription/enums";
var SupportersAmountForm = function SupportersAmountForm(_ref) {
    var namespace = _ref.namespace;
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: "block mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "select-field"
    }, /*#__PURE__*/ React.createElement(Field, {
        as: "select",
        name: withNamespace(AMOUNT, namespace)
    }, SubscriptionsMeta[SubscriptionType.SUPPORTER].prices.map(function (p, i) {
        return /*#__PURE__*/ React.createElement("option", {
            value: p,
            key: p
        }, p.toLocaleString("de", {
            minimumFractionDigits: 2
        }), " \u20AC");
    })))));
};
export default SupportersAmountForm;
